import { render, staticRenderFns } from "./noticeAddPage.vue?vue&type=template&id=3ea88a80&scoped=true&"
import script from "./noticeAddPage.vue?vue&type=script&lang=js&"
export * from "./noticeAddPage.vue?vue&type=script&lang=js&"
import style0 from "./noticeAddPage.vue?vue&type=style&index=0&id=3ea88a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea88a80",
  null
  
)

export default component.exports